import * as yup from "yup";

export const alignerMaterialSchema = yup.object().shape({
  name: yup.string().required("Name is required"),
});
